// Mes paiements (toutes collectivités) : montant, état en texte coloré, canal, date, quittance.
import { EtatVide } from '@cc/ui';
import { CreditCard } from 'lucide-react';
import { EtatRequete } from '../../../commun/EtatRequete';
import { dateHeure } from '../../../commun/format';
import { EnTeteCitoyen, ExigeConnexion, Ligne, Liste, TexteStatut } from '../commun';
import { useMesPaiements } from './api';
import { LIBELLES_CANAL_PAIEMENT, libelleEtatPaiement, montant, tonEtatPaiement } from './logique';
import styles from '../citoyen.module.css';

export function PageMesPaiements() {
  const paiements = useMesPaiements();
  const liste = [...(paiements.data ?? [])].sort((a, b) => b.initie_le.localeCompare(a.initie_le));
  return (
    <>
      <EnTeteCitoyen titre="Mes paiements" retour="/citoyen/paiements" libelleRetour="Paiements" sousTitre="Paiements en ligne et reçus de caisse vérifiés, dans toutes les collectivités." />
      <ExigeConnexion titre="Connectez-vous pour voir vos paiements">
        <EtatRequete chargement={paiements.isPending} erreur={paiements.error} onReessayer={() => void paiements.refetch()} fonction="Vos paiements" lot="L2" lignes={5}>
          {liste.length === 0 ? (
            <EtatVide titre="Aucun paiement" icone={CreditCard}>
              <p>Vos paiements apparaîtront ici dès le premier règlement d&apos;une créance.</p>
            </EtatVide>
          ) : (
            <Liste libelle="Paiements">
              {liste.map((p) => (
                <Ligne
                  key={p.id}
                  href={`/citoyen/paiements/suivi/${p.reference_serveur}`}
                  titre={<span className={styles.mono}>{montant(p.montant)}</span>}
                  sousTitre={[p.collectivite.nom, LIBELLES_CANAL_PAIEMENT[p.canal] ?? p.canal, dateHeure(p.initie_le), p.quittance ? `quittance ${p.quittance.numero}` : null].filter(Boolean).join(' · ')}
                  droite={<TexteStatut libelle={libelleEtatPaiement(p.etat)} ton={tonEtatPaiement(p.etat)} />}
                />
              ))}
            </Liste>
          )}
        </EtatRequete>
      </ExigeConnexion>
    </>
  );
}
